import React from "react";
import StationTag from "./components/station-tag";
import EquipTypeTag from "./components/equip-type-tag";
import PriceLabel from "./components/price-label";
import { goToNativePage } from "../../utils/common";
import "./index.less";
import { trackGdp } from "../../utils/gio-report";

interface StationItemProps {
  station: any;
  showDistance?: boolean;
  withLine?: boolean;
  showAddress?: boolean;
  showAct?: boolean;
  showPrice?: boolean;
  price?: string;
  distanceLabel?: string;
  className?: string;
  isSharePile?: boolean;
  from?: string;
  showTab?: boolean;
}

const StationItem = (props: StationItemProps) => {
  const {
    station,
    showDistance,
    withLine = true,
    showAddress = false,
    showAct = true,
    showPrice = true,
    price = "",
    distanceLabel = "",
    className = "",
    isSharePile = false,
    from = "",
    showTab = true,
  } = props;
  console.log(station, "station");

  const onGoDetail = (stationId: number | string) => {
    // 上报埋点
    from === "heap" && trackGdp("P20180", "B017", { stationId });

    const appUrl = isSharePile
      ? `xiaopeng://xrn/dynamicPage?launchPage=XPMotors_ReactNativeHomePileStationDetail&stationId=${stationId}`
      : `xiaopeng://charging/station/detail?id=${stationId}`;

    const miniUrl = isSharePile
      ? `/pages/home-pile-station-detail/index?stationId=${stationId}`
      : `/charging/pages/station-detail/index?stationId=${stationId}`;

    let env = "release";
    if (
      window.location.href.indexOf("static.deploy-test.xiaopeng.com") !== -1
    ) {
      env = "develop";
    }
    const browserUrl = `${window.location.origin}/apps/charge-web/jump-to-wx-mini.html?page=${isSharePile ? `pages/home-pile-station-detail/index` : `charging/pages/station-detail/index`}&query=stationId%3D${stationId}&version=${env}`;

    goToNativePage({
      app: appUrl,
      mini: miniUrl,
      browser: browserUrl,
    });
  };

  return (
    <div
      className={`station-card-wrap ${station?.stationAvailabilityDesc ? "disabled" : ""} ${className}`}
      key={station?.stationId}
      onClick={() => onGoDetail(station?.stationId)}
    >
      <div className="title-row">
        <span className="name">{station?.stationName}</span>
        {showDistance && (!!station?.distance || distanceLabel) ? (
          <div className="location-info">
            {!distanceLabel && (
              <img
                className="location-icon"
                alt=""
                src={`https://s.xiaopeng.com/xp-charge/mini/common/navigator-pointer.png`}
              />
            )}
            <span className="distance">
              {distanceLabel}
              {station?.distance}km
            </span>
          </div>
        ) : null}
      </div>
      {showTab && (
        <StationTag
          disabled={!!station?.stationAvailabilityDesc}
          useInDetail={false}
          stationLabelList={station?.stationLabelList}
          className="station-tag"
        />
      )}
      {showAddress && (
        <div className="stationAddress">{station?.stationAddr || "--"}</div>
      )}
      <div className="pile-info-row">
        {showPrice && (
          <div className="price-info">
            <span className="prefix">￥ </span>
            <span className="num">
              {price || station?.stationBillingInfo?.minTotalPrice || "--"}
            </span>
            <span className="unit">
              /度{" "}
              {station?.stationBillingInfo?.minTotalPrice !==
                station?.stationBillingInfo?.totalPrice && !price
                ? "起"
                : ""}
            </span>
            {[1, 2].includes(station?.stationActivityInfoV5?.activityType) && (
              <span className="origin-price">
                {station?.stationActivityInfoV5?.activityPriceDesc}
              </span>
            )}
          </div>
        )}
        <div className="pile-status">
          {station?.stationEquipOverViewList?.length > 0 &&
            station?.stationEquipOverViewList.map((eItem, eIndex) => (
              <div className="equipTypeList" key={eIndex + eItem?.type}>
                <EquipTypeTag
                  type={eItem?.chargePowerType}
                  name={eItem?.typeName}
                  isDisabled={!!station?.stationAvailabilityDesc}
                />
                <div className="status">
                  <span className="idle">
                    {[1, 2].includes(
                      station?.stationActivityInfoV5?.activityType,
                    ) && station?.stationEquipOverViewList?.length > 2
                      ? ""
                      : "闲 "}
                    {eItem?.freeNums}
                  </span>
                  <span className="all">/{eItem?.nums}</span>
                </div>
              </div>
            ))}
        </div>
      </div>
      {showAct && (
        <PriceLabel
          className="station-activity-tag"
          disabled={!!station?.stationAvailabilityDesc}
          showBackUpText={false}
          labelInfo={station?.stationActivityInfoV5}
        />
      )}
      {station?.stationAvailabilityDesc ? (
        <div className="error-tip">{station?.stationAvailabilityDesc}</div>
      ) : null}
      {withLine && <div className="devide-bottom-line"></div>}
    </div>
  );
};

export default StationItem;
